module.exports = __webpack_public_path__ + "img/bg4.3eef379c.jpg";